<template>
    <b-card :disabled="busy">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">{{$t('email.email_management')}}</h4>

                <b-button :disabled="busy" class="ml-3" @click.prevent="toggleDialogEmail()" variant="primary" size="sm">
                    <i class="icon-plus2"></i> {{$t('email.button_add_account')}}
                </b-button>
            </div>
        </template>

        <div class="table-responsive">
            <b-table show-empty
                     class="table-xs"
                     :filter="q"
                     :items="accounts"
                     :fields="fields"
                     :per-page="pagination.perPage"
                     :current-page="pagination.currentPage"
                     :empty-text="$t('email.no_results')"
                     :empty-filtered-text="$t('email.no_results_found')"
            >
                <template v-slot:cell(options)="data">
                    <div v-if="data.item.ownerUuid === user.uuid">
                        <button type="button" @click.prevent="handleDelete(data.item.uuid)" class="btn btn-light btn-xs mr-1">
                            <i class="icon-bin"/>
                        </button>
                        <button type="button" @click.prevent="toggleDialogAssign(data.item.uuid)" class="btn btn-light btn-xs mr-1">
                            <i class="icon-link"/>
                        </button>
                        <button type="button" @click.prevent="toggleDialogEmail(data.item.uuid)" class="btn btn-light btn-xs mr-1">
                            <i class="icon-pencil5"/>
                        </button>
                    </div>
                    <b-badge v-else variant="secondary">{{$t('email.account_unavailable')}}</b-badge>
                </template>
            </b-table>
        </div>

        <emails-modal
                v-if="modalEmail.open"
                :email-uuid="modalEmail.uuid"
                @hidden="toggleDialogEmail()"
        />

        <assignments-modal
                v-if="dialogAssign.open"
                :mailbox-uuid="dialogAssign.uuid"
                @hidden="toggleDialogAssign()"
        />

    </b-card>
</template>

<script>
    import EmailsModal from "./EmailsModal";
    import AssignmentsModal from "./AssignmentsModal";

    import {mapGetters} from 'vuex';

    export default {
        name: "EmailsPanel",
        components: { EmailsModal, AssignmentsModal },

        computed: {
            ...mapGetters('Email', ['accounts']),
            ...mapGetters('Auth', ['user']),

            accountsCount() {
                return this.accounts.length;
            },

            showPagination() {
                return this.accountsCount > this.pagination.perPage;
            }
        },

        created() {
            this.busy = true;
            this.$store.dispatch('Email/fetchAccounts')
                .finally(() => {
                    this.busy = false;
                })
            ;
        },

        methods: {
            toggleDialogEmail(uuid = '') {
                this.modalEmail.open = !this.modalEmail.open;
                this.modalEmail.uuid = String(uuid);
            },

            toggleDialogAssign(uuid = '') {
                this.dialogAssign.open = !this.dialogAssign.open;
                this.dialogAssign.uuid = String(uuid);
            },

            handleDelete(uuid) {
                this.busy = true;
                this.$store.dispatch('Email/deleteAccount', uuid)
                    .finally(() => { this.busy = false; })
                ;
            }
        },

        data() {
            return {

                busy: false,

                modalEmail: {
                    open: false,
                    uuid: ''
                },

                dialogAssign: {
                    open: false,
                    uuid: ''
                },

                pagination: {
                    perPage: 10,
                    currentPage: 1,
                },

                q: '',
                fields: [
                    {
                        key: 'email',
                        label: 'Email',
                        class: 'min text-left'
                    },
                    {
                        key: 'options',
                        label: '',
                        class: 'min text-nowrap text-right'
                    }
                ],
            }
        }
    }
</script>

<style scoped>

</style>